const state = {
  difficultyOption: [
    { label: '全部', value: null },
    { label: '容易', value: 1 },
    { label: '中等', value: 2 },
    { label: '困难', value: 3 }
  ],
  searchfieldsOption: [
    { label: '器官', value: 'organ' },
    { label: '题目编号', value: 'questionNo' }
  ],
  mysearchfieldsOption: [
    { label: '器官', value: 'organ' },
    { label: '题目编号', value: 'questionNo' },
    { label: '公共题目编号', value: 'oldQuestionNo' }
  ],
  modalityOption: [
    { label: 'CT', value: 'CT' },
    { label: 'XA', value: 'XA' },
    { label: 'MR', value: 'MR' },
    { label: 'MG', value: 'MG' },
    { label: 'RF', value: 'RF' },
    { label: 'DX', value: 'DX' },
    { label: 'CR', value: 'CR' }
  ],
  practiceType: 0
}
const mutations = {
  changePracticeType (state, v) {
    state.practiceType = v;
  }
}
const actions = {
}
export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/virtual.js